import React from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

function UserProgressBar ({ currentUsers, milestone = 100, milestoneNumber = 1, type = 'regular' }) {
  const percentage = Math.min((currentUsers / milestone) * 100, 100)

  return (
    <div className={cn(styles.container, { [styles['second-type']]: type !== 'regular' })}>
      <h2 className={styles.title} style={{ marginBottom: 0 }}>Milestone #{milestoneNumber}</h2>
      <h2 className={styles.title}>First {milestone} Registered People</h2>
      <div className={styles.progressWrapper}>
        <div className={styles.progressBlurBackground} />
        <div
          className={styles.progressFill}
          style={{ width: `${percentage}%` }}
        />
        <div className={styles.progressText}>
          {currentUsers} / {milestone} people
        </div>
      </div>
      {type !== 'regular' && <small style={{ color: 'gray' }}>*people registered right now will be eligible for future airdrop</small>}
    </div>
  )
}

export default UserProgressBar
